import "./home.scss";
import Logo from "../../assets/logo.png";
import { AuthContext } from "../../context/AuthContext";
import { useContext, useState, useEffect } from "react";
import useDocumentTitle from "../../components/Title";

const appUrl = process.env.REACT_APP_URL_BACKEND;

const Home = () => {
  const titleGrid = "Panel Principal";
  useDocumentTitle(titleGrid);
  const { empresaData = {}, user } = useContext(AuthContext);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const imageUrl = empresaData?.imagen_sitio
    ? `${appUrl}${empresaData.imagen_sitio}`
    : Logo;

  const getGreeting = () => {
    const hour = currentTime.getHours();
    if (hour < 12) return "¡Buenos días";
    if (hour < 18) return "¡Buenas tardes";
    return "¡Buenas noches";
  };

  const formatDate = (date) =>
    date.toLocaleDateString("es-AR", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  const formatTime = (date) =>
    date.toLocaleTimeString("es-AR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

  const userName = user?.sel_firstname ? `, ${user.sel_firstname}!` : "!";

  return (
    <div className="home">
      <div className="homeContainer">
        <div className="hero-home">
          <div className="hero-bg-shapes">
            <span className="shape shape-1"></span>
            <span className="shape shape-2"></span>
            <span className="shape shape-3"></span>
            <span className="shape shape-4"></span>
          </div>
          <div className="hero-card">
            <div className="hero-logo-wrapper">
              <img src={imageUrl} alt="Logo" className="hero-logo" />
            </div>
            <div className="hero-info">
              <h1 className="hero-company">
                {empresaData?.nombre_sitio || "Panel de Control"}
              </h1>
              <p className="hero-greeting">
                {getGreeting()}
                {userName}
              </p>
              <div className="hero-datetime">
                <span className="hero-date">{formatDate(currentTime)}</span>
                <span className="hero-time">{formatTime(currentTime)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
